import React from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { LuGift } from "react-icons/lu";
import { emptyStateIllustrations } from "../assets/empty-states";
import { Card, CardHeader, QueryState } from "../components/blocks";
import Sorteo from "../components/templates/sorteoTemplate";
import { Apis } from "../util/Apis";

const Sorteos = () => {
  const salaInfo = JSON.parse(localStorage.getItem("salaInfo"));

  const { data: sorteosdelDia, isLoading, error } = useQuery({
    queryKey: ["sorteos", salaInfo?.salaId],
    queryFn: async () => {
      const res = await axios.get(Apis.CAPP + "/sorteos", {
        headers: { "X-Sala-Id": salaInfo.salaId },
      });
      return res.data;
    },
    enabled: !!salaInfo?.salaId,
  });

  return (
    <>
      <QueryState
        data={sorteosdelDia}
        isLoading={isLoading}
        error={error}
        emptyProps={{
          title: "No hay sorteos disponibles para el dia de hoy",
          subtitle: "Vuelva a intentarlo mas tarde, o consulte con un asesor",
          illustration: emptyStateIllustrations.raffles,
          illustrationAlt: "Sin sorteos disponibles",
        }}
      >
        {(data) => (
          <div className="flex flex-col w-full gap-4">
            <Card>
              <CardHeader
                title="Sorteos"
                subtitle="Sorteos disponibles del dia de hoy"
                icon={<LuGift size={24} />}
              />
              <div className="flex flex-row items-center justify-end w-full gap-2">
                <span className="text-xl font-extrabold leading-tight">
                  {Math.floor(data.length || 0)}
                </span>
                <span className="font-normal leading-tight text-slate-600">
                  {data.length === 1 ? "sorteo" : "sorteos"}
                </span>
              </div>
            </Card>

            <Sorteo datasorteo={data} />
          </div>
        )}
      </QueryState>
    </>
  );
};

export default Sorteos;
